module.exports = __webpack_public_path__ + "digitalradar_münsterland_final_1x.c69d934ff59243330529a34d842d8a2d.png";